/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CombinationDto } from './combinationDto';
import { ImplementDataDto } from './implementDataDto';
import { MachineDataDto } from './machineDataDto';

export interface CombinationStatsV2Dto {
  combination?: CombinationDto;
  implementData?: ImplementDataDto;
  implementDataField?: ImplementDataDto;
  implementDataLocation?: ImplementDataDto;
  implementDataRoad?: ImplementDataDto;
  machineData?: MachineDataDto;
  machineDataField?: MachineDataDto;
  machineDataLocation?: MachineDataDto;
  machineDataRoad?: MachineDataDto;
}
